export function getFirstDayForNextWeek() : Date
{
    // Get the current date
    var currentDate = new Date();
    currentDate.setHours(0)
    currentDate.setMinutes(0)
    currentDate.setSeconds(0)
    currentDate.setMilliseconds(0)

    // Get the current day of the week (0-6)
    var currentDayOfWeek = currentDate.getDay();

    // Calculate the number of remaining days until the end of the week
    var remainingDays = (currentDayOfWeek > 0) ? (6 - currentDayOfWeek) : 0;

    // Calculate the first day of the following week
    var firstDayOfFollowingWeek = new Date(currentDate);
    firstDayOfFollowingWeek.setDate(currentDate.getDate() + remainingDays + 2);

    // Si el primer dia de la semana que viene es LUNES, el usuario se debe inscribir el MARTES,
    // para que les de tiempo a gestionar la inscripción.
    const firstWeekDayNumberOfFollowingWeek = firstDayOfFollowingWeek.getDay()
    if(firstWeekDayNumberOfFollowingWeek === 1){
        firstDayOfFollowingWeek.setDate(firstDayOfFollowingWeek.getDate() + 1);
    }

    // Output the first day of the following week
    // console.log(firstDayOfFollowingWeek);
    // console.log(firstDayOfFollowingWeek.getDay());

    return firstDayOfFollowingWeek
}

export function getNextWeekTuesday(currentDate = new Date()) : Date
{
    // Normalizar la fecha actual a medianoche
    const date = new Date(currentDate);
    date.setHours(0)
    date.setMinutes(0)
    date.setSeconds(0)
    date.setMilliseconds(0)

    // Obtener el día de la semana actual (0 = Domingo, 1 = Lunes, ..., 6 = Sábado)
    const currentDayOfWeek = date.getDay();

    // Calcular los días hasta el martes de la semana siguiente
    // Martes = 2
    // Días hasta el próximo lunes (inicio de la semana siguiente) + 1 para llegar al martes
    let daysUntilNextTuesday: number;

    if (currentDayOfWeek === 0) {
        // Domingo -> martes de la semana siguiente = 9 días
        daysUntilNextTuesday = 9;
    } else {
        // Lunes a Sábado: ir al lunes siguiente (7 - currentDayOfWeek + 1) y sumar 1 para el martes
        daysUntilNextTuesday = (7 - currentDayOfWeek) + 2;
    }

    const nextTuesday = new Date(date);
    nextTuesday.setDate(date.getDate() + daysUntilNextTuesday);

    return nextTuesday;
}
